import { Component, OnInit } from '@angular/core';

import { LocalStorageService } from '../../../../shared/services/local-storage/local-storage.service';
import { AgendasService } from '../../../../shared/services/agendas/agendas.service';

import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-agenda-financeira',
  templateUrl: './agenda-financeira.component.html',
  styleUrls: ['./agenda-financeira.component.scss']
})
export class AgendaFinanceiraComponent implements OnInit {
  public table: any;

  public error = false;
  public loaded = false;

  public inputSearch = '';

  public agendamentos: any[] = [];
  public _agendamentos: any[] = [];

  request: any;

  public page = 1;

  user: any;
  lastSelection: any;
  firstSelection: any;

  isClick = false;

  isLoading = false;

  constructor(
    private agendasService: AgendasService,
    private localStorageService: LocalStorageService,
  ) { }

  ngOnInit() {
    this.showData();
  }

  setFilterData(e?: any) {
    const user = this.localStorageService.get('login');
    if (!user || !user.PersonId) { return; }

    this.page = 1;
    this.user = user;

    if (e) {
      this.firstSelection = e.firstSelection;
      this.lastSelection = e.lastSelection;
    }

    this.getAgendamentos();
  }

  getAgendamentos() {
    this.agendasService.consultar(
      new Date(this.firstSelection.year, this.firstSelection.month - 1, this.firstSelection.day).toISOString(),
      new Date(this.lastSelection.year, this.lastSelection.month - 1, this.lastSelection.day).toISOString(),
      this.user.PersonId,
      this.page
    ).subscribe((data: any) => {
      this.loaded = true;
      this.agendamentos = data.Agendamentos;

      this.request = data;

      this.agendamentos.sort(function(a, b) {
        const dateA = a.DataPrevisao;
        const dateB = b.DataPrevisao;
        if (moment(dateA).isAfter(dateB)) { return 1; }
        if (!moment(dateA).isAfter(dateB)) { return -1; }
        return 0;
      });

      this.agendamentos.forEach((agendamento: any) => {
        agendamento.DataPrevisao = moment(agendamento.DataPrevisao).format('DD/MM/YYYY');
        agendamento.Valor = agendamento.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      });

      this._agendamentos = JSON.parse(JSON.stringify(this.agendamentos));

      this.showData();
    }, (err) => {
      this.error = true;
      console.error(err);
    });
  }

  showData() {
    const self = this;
    $.fn.dataTable.moment('DD/MM/YYYY');

    this.table = $('#master-detail-table-agenda-financeira').DataTable({
      scrollX: true,
      destroy: true,
      paging: true,
      pagingType: 'numbers',
      pageLength: 26,
      lengthChange: false,
      searching: false,
      processing: false,
      info: true,
      data: self.agendamentos,
      bSort: false,
      language: {
        emptyTable: ' ',
        info: '_START_ - _END_ de _MAX_',
      },
      initComplete: function(e) {
        self.loaded = true;

        $('.paging_numbers').show();
        $('.dataTables_info').show();
      },
      columns: [
        { title: 'Valor', data: 'Valor' },
        { title: 'Cliente', data: 'NomeCliente' },
        { title: 'Previsão', data: 'DataPrevisao' },
        { title: 'Qtd. Parcelas', data: 'Parcelas' },
      ],
    });

    const page: any = self.page;

    $('#master-detail-table-agenda-financeira').on('draw.dt', function() {
      $('#master-detail-table-agenda-financeira_info').html('');
      $('#master-detail-table-agenda-financeira_paginate').html('');

      if (!self.request) { return; }

      for (let i = 0; i < self.request.NumeroPagina; i++) {
        $('#master-detail-table-agenda-financeira_paginate')
        .append(
          '<span>' +
            '<a class="paginate_button ' +
              ((parseInt(page, 10) === i + 1) ? 'current' : '') +
              '" aria-controls="master-detail-table-agenda-financeira" data-dt-idx="' + i + '" tabindex="0">' +
              (i + 1) +
            '</a>' +
          '</span>');
      }
    });

    self.table.page(self.page - 1).draw('page');

    $('.paginate_button').click(function(e) {
      self.loaded = false;
      self.page = e.target.innerHTML;

      self.getAgendamentos();

      $('.paging_numbers').hide();
      $('.dataTables_info').hide();
    });
  }
}
